import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import useDocumentMeta from "../hooks/useDocumentMeta.js";
import usePageLanguage from "../hooks/usePageLanguage.js";
import { alternatesFor, canonicalUrlFor } from "../content/pages/registry.js";
import usePageShell from "../hooks/usePageShell.js";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import ContactIntro from "../components/contact/ContactIntro";
import ContactForm from "../components/contact/ContactForm";
import ContactClosingMessage from "../components/contact/ContactClosingMessage";
import InstagramFeed from "../components/home/InstagramFeed";
import CtaSection from "../components/home/CtaSection";
import useAnalyticsContext from "../hooks/useAnalyticsContext.js";
import { trackCTA, trackContact, trackLead } from "../lib/analytics";

/** This page's language-neutral path — the key the registry looks it up by. */
const PATH = "/contact";

const Contact = () => {
  const { t } = useTranslation();
  const analyticsContext = useAnalyticsContext();
  const language = usePageLanguage();

  // Self-referencing, per language, from the registry — see the note in
  // LegalPageLayout. /contact has its own static document in both languages
  // now; this still runs for a client-side arrival, where none is fetched.
  useDocumentMeta({
    titleKey: "meta.contact.title",
    descriptionKey: "meta.contact.description",
    canonical: canonicalUrlFor(PATH, language),
    alternates: alternatesFor(PATH),
    robots: "index, follow",
  });

  useEffect(() => {
    // Fire once per /contact visit; capture the mount-time page/language.
    trackContact(analyticsContext);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  usePageShell();

  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="main">
        <ContactIntro />
        <ContactForm />
        <ContactClosingMessage />
        <InstagramFeed />
        <CtaSection
          text={t("home.cta.startJourney")}
          href={`${import.meta.env.VITE_APP_URL}/couple/create-event`}
          onClick={() => {
            trackCTA("contact_final_cta", {
              ...analyticsContext,
              ctaName: "register",
            });
            trackLead("contact_final_cta", {
              ...analyticsContext,
              ctaName: "register",
            });
          }}
        />
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
